<template>
  <div :class="$style.frameGroup">
    <div v-if="loading" class="loading-overlay">
      <b-spinner
        label="Loading..."
        variant="primary"
        class="spinner"
      ></b-spinner>
    </div>
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.formGroup">
        <div>Height</div>
        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <span :class="$style.suffix">FT</span>
            <input
              type="number"
              v-model="form.heightFeet"
              placeholder="Type feet..."
            />
          </div>
          <div :class="$style.formGroup">
            <span :class="$style.suffix">IN</span>
            <input
              type="number"
              v-model="form.heightInches"
              placeholder="Type inches..."
            />
          </div>
        </div>
      </div>

      <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
        <div :class="$style.formGroup">
          <div>Weight</div>
          <span :class="$style.suffix">LBS</span>
          <input
            type="number"
            v-model="form.weight"
            placeholder="Type weight in pounds..."
          />
        </div>
        <div :class="$style.formGroup">
          <div>Gender</div>
          <HiloSelect
            id="genderId"
            :theme="'grey'"
            v-model="form.genderId"
            :options="gendersList"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>
      </div>

      <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
        <div :class="$style.formGroup">
          <div>Do you have flight experience?</div>
          <HiloSelect
            id="flightExperience"
            :theme="'grey'"
            v-model="form.flightExperience"
            :options="[
              { id: true, name: 'Yes' },
              { id: false, name: 'No' },
            ]"
            :placeholder="'Choose one...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>
        <div :class="$style.formGroup">
          <div>How many hours do you have?</div>
          <input
            type="number"
            v-model="form.flightHours"
            placeholder="Type hours..."
          />
        </div>
      </div>

      <div :class="$style.formGroup">
        <div>Which of these ratings do you have?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.ratings"
          multi-select
          :options="ratingsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What or who inspired you to pursue a career in aviation?</div>
        <input
          type="text"
          v-model="form.whoInspired"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>How do you handle challenges or setbacks?</div>
        <input
          type="text"
          v-model="form.handleChallenges"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>In what environments do you learn best?</div>
        <HiloSelect
          :theme="'grey'"
          multi-select
          v-model="form.learningEnvironments"
          :options="learningEnvironmentsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          What is one trait you possess that will make you a great pilot?
        </div>
        <input
          type="text"
          v-model="form.personalityTrait"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          What are your long term goals both within and outside of aviation?
        </div>
        <input
          type="text"
          v-model="form.longTermGoals"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the highest level of education you have achieved?</div>
        <HiloSelect
          id="educationLevelId"
          :theme="'grey'"
          v-model="form.educationLevelId"
          :options="educationLevelsList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Will you be training part time or full time?</div>
        <HiloSelect
          id="fullOrPartTimeId"
          :theme="'grey'"
          v-model="form.fullOrPartTimeId"
          :options="fullOrPartTimeList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <p>Provide two references flight schools can contact:</p>
      </div>

      <div
        :class="$style.flexGroup"
        v-for="(reference, index) in form.references"
        :key="index"
      >
        <div :class="$style.formGroup">
          <div>Reference {{ index + 1 }}:</div>
          <input v-model="reference.name" type="text" placeholder="Name..." />
        </div>
        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <input
              v-model="reference.phone"
              type="text"
              placeholder="Phone..."
            />
          </div>
          <div :class="$style.formGroup">
            <input
              v-model="reference.email"
              type="email"
              placeholder="Email..."
            />
          </div>
        </div>
        <div :class="$style.formGroup">
          <HiloSelect
            :id="'relationshipList' + index"
            :theme="'grey'"
            v-model="reference.relationshipId"
            :options="relationshipsList"
            :placeholder="'Relationship...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>
      </div>

      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b>Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b>Back</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";
const aboutYouAPIService = new AboutYouAPIService();
import UsersAPIService from "@/servicehandlers/UsersAPIService.js";
const usersAPIService = new UsersAPIService();
import get from "lodash/get";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        heightFeet: "",
        heightInches: "",
        weight: "",
        genderId: "",
        flightExperience: "",
        flightHours: "",
        whoInspired: "",
        handleChallenges: "",
        personalityTrait: "",
        longTermGoals: "",
        educationLevelId: "",
        fullOrPartTimeId: "",
        ratings: [],
        learningEnvironments: [],
        references: [
          { name: "", phone: "", email: "", relationshipId: "" },
          { name: "", phone: "", email: "", relationshipId: "" },
        ],
      },
      gendersList: [],
      relationshipsList: [],
      educationLevelsList: [],
      fullOrPartTimeList: [],
      learningEnvironmentsList: [],
      ratingsList: [],
      loading: false,
      emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      phoneRegex: /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/,
      validations: [
        { field: "heightFeet", desc: "height" },
        { field: "heightInches", desc: "height" },
        { field: "weight", desc: "weight" },
        { field: "genderId", desc: "gender" },
        { field: "flightExperience", desc: "flight experience response" },
        { field: "flightHours", desc: "flight hours response" },
        { field: "ratings", desc: "rating" },
        { field: "whoInspired", desc: "who inspired you response" },
        { field: "handleChallenges", desc: "handle challenges response" },
        { field: "learningEnvironments", desc: "learning environment" },
        { field: "personalityTrait", desc: "personality trait" },
        { field: "longTermGoals", desc: "long term goal" },
        { field: "educationLevelId", desc: "level of education" },
        { field: "fullOrPartTimeId", desc: "training time" },
        { field: "references[0].name", desc: "first reference name" },
        {
          field: "references[0].phone",
          regex: "phoneRegex",
          desc: "first reference phone number",
        },
        {
          field: "references[0].email",
          regex: "emailRegex",
          desc: "first reference email address",
        },
        {
          field: "references[0].relationshipId",
          desc: "first reference relationship",
        },
        { field: "references[1].name", desc: "second reference name" },
        {
          field: "references[1].phone",
          regex: "phoneRegex",
          desc: "second reference phone number",
        },
        {
          field: "references[1].email",
          regex: "emailRegex",
          desc: "second reference email address",
        },
        {
          field: "references[1].relationshipId",
          desc: "second reference relationship",
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getAboutYouLists();
      await this.getAboutYouSavedData();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.gendersList,
          this.relationshipsList,
          this.educationLevelsList,
          this.fullOrPartTimeList,
          this.learningEnvironmentsList,
          this.ratingsList,
        ] = await Promise.all([
          usersAPIService.getGenders(),
          aboutYouAPIService.getRelationshipsList(),
          aboutYouAPIService.getEducationLevelsList(),
          aboutYouAPIService.getFullOrPartTimeList(),
          aboutYouAPIService.getLearningEnvironmentsList(),
          aboutYouAPIService.getRatingsList(),
        ]);
        this.ratingsList = this.ratingsList.filter(
          (rating) => rating.aboutYouStudent,
        );
        this.relationshipsList = this.relationshipsList.filter(
          (relationship) => relationship.abtYouStudent,
        );
      } catch (error) {}
    },
    async getAboutYouSavedData() {
      try {
        const fetchedData = await aboutYouAPIService.getStudentByUserId(
          this.userId,
        );
        if (fetchedData) {
          this.form = { ...this.form, ...fetchedData };
        }
        if (
          Array.isArray(this.form.references) &&
          this.form.references.length === 0
        ) {
          this.form.references = [
            { name: "", phone: "", email: "", relationshipId: "" },
            { name: "", phone: "", email: "", relationshipId: "" },
          ];
        }
      } catch (error) {}
    },
    async handleNext() {
      let isValid = true;
      for (const validation of this.validations) {
        const { field, desc, regex } = validation;

        const fieldValue = get(this.form, field);

        if (
          fieldValue === undefined ||
          fieldValue === null ||
          fieldValue === "" ||
          (Array.isArray(fieldValue) && fieldValue.length === 0)
        ) {
          isValid = false;
          alert(`Please enter a ${desc}`);
          break;
        }

        if (regex && this[regex] && !this[regex].test(fieldValue)) {
          isValid = false;
          alert(`Please enter a valid ${desc}`);
          break;
        }
      }

      if (!isValid) return;
      try {
        this.loading = true;
        const aboutYouData = {
          ...this.form,
          userId: this.userId,
        };
        if (this.userId)
          await aboutYouAPIService.createOrUpdateStudent(aboutYouData);
        this.$emit("onNext", { aboutYou: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style module scoped>
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}

.suffix {
  position: absolute;
  right: 10px;
  bottom: 12px;
  font-size: 13px !important;
  background-color: #f5f5f5;
  padding-left: 15px;
}
</style>
